import {useEffect} from 'react';
import * as Sentry from '@sentry/react';
import ReactGA from 'react-ga4';
import Hotjar from '@hotjar/browser';

/**
 * Custom hook to handle auth initialization logic
 * Initializes analytics, tracking, and other services when auth changes
 */
const useAuthInitialization = (auth, setBillingDetailsStatus) => {
  useEffect(() => {
    if (!auth) {
      return;
    }

    // Init Global site tag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());

    // Only fire google conversion event to Google pixel on first login for the user
    if (auth.firstLogin) {
      // gtag('event', 'conversion', {send_to: 'AW-820817374/LH9ICJzbyMoBEN7bsocD'});
      ReactGA.set({userId: auth.username});
    }

    // Set Sentry user for error tracking
    Sentry.setUser({
      id: auth.fos_user_id,
    });

    // Update billing details status
    setBillingDetailsStatus(auth.billingDataCheck);

    // Non WB-logins initialization
    if (
      !auth.wb_auth &&
      !auth.username?.includes('demo') &&
      process.env.REACT_APP_CURRENT_BRANCH === 'master'
    ) {
      // Initialize Hotjar with different site IDs based on account type
      Hotjar.init(auth.type >= 5 ? 5002883 : 5311917, 6);
      Hotjar.identify(auth.username, {
        userId: auth.fos_user_id,
        type: auth.type,
        firstLogin: auth.firstLogin,
        onboarding_enabled: auth.onboarding_enabled,
        onboarding_completed: auth.onboarding_completed,
        adserver_onboarding_completed: auth.adserver_onboarding_completed,
      });
      ReactGA.set({userId: auth.username});
    }
  }, [auth, setBillingDetailsStatus]);
};

export default useAuthInitialization;
